import { generateNonce } from "@/helpers/noncehelper";
import { fetchSafeJson } from "@/utils/apiResponse";
import { encrypt } from "@/utils/encrypt";
import { fetchOffers, loadOffers } from "../newRelic";

/**
 * Fetch all Mulesoft offers Data.
 * @returns {Promise<any | null>}
 */
export const fetchMulesoftOffers = async (payload: {
  key: string;
  cardNumber: string;
  token: string;
  isHash?: boolean;
}): Promise<any | null> => {
  try {
    const cardNumber = payload.isHash? payload?.cardNumber :'';
    const data = encrypt(
      JSON.stringify({
        key: payload?.key ?? `${process.env.NEXT_PUBLIC_MULESOFT_KEY}`,
        payload: {
          cardNumber: cardNumber,
          legacy: false,
          daysRange: 30,
          preferredLanguage: "en",
        },
      })
    );
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/offerRequest`,
      {
        method: "POST",
        headers: {
          focus: `${payload.token}`,
          Authorization: `Bearer ${encrypt(crypto.randomUUID()).toUpperCase()}`,
          "Content-Type": "application/json",
          "x-nonce-token": generateNonce(),
          "is-email": payload.isHash ? "true" : "false",
        },
        body: JSON.stringify({ data }),
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch all offers. Status: ${response.status}`);
    }

    const responseData = await response.json();
    const finalResponse = await fetchSafeJson(responseData);
    console.log(await finalResponse, "finalResponse");
    fetchOffers(
      "success",
      20,
      process.env.NEXT_PUBLIC_LOCALE,
      finalResponse?.response?.pendingOffers?.length,
      finalResponse?.response?.activeOffers?.length,
      finalResponse?.response?.redeemedOffers?.length,
      finalResponse?.response?.expiredOffers?.length
    );
    return await finalResponse;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch all offers");
  }
};

export const mulesoftMemberInquireService = async (payload: {
  key: string;
  cardNumber: string;
  token: string;
  isHash?: boolean;
}): Promise<any | null> => {
  try {
    const cardNumber = payload?.isHash ? payload?.cardNumber :'';
    const data = encrypt(
      JSON.stringify({
        key: payload.key,
        payload: {
          cardNumber: cardNumber,
        },
      })
    );
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/offerRequest`,
      {
        method: "POST",
        headers: {
          focus: `${payload.token}`,
          Authorization: `Bearer ${encrypt(crypto.randomUUID()).toUpperCase()}`,
          "Content-Type": "application/json",
          "x-nonce-token": generateNonce(),
          "is-email": payload.isHash ? "true" : "false",
        },
        body: JSON.stringify({ data }),
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch all offers. Status: ${response.status}`);
    }

    const responseData = await response.json();
    return await fetchSafeJson(responseData);
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch all offers");
  }
};

export const mulesoftLoadOffersService = async (payload: {
  key: string;
  cardNumber: string;
  userId: string;
  offers: any[];
  token: string;
  isHash: boolean;
}): Promise<any | null> => {
  try {
    const cardNumber = payload.isHash? payload?.cardNumber :'';
    const data = encrypt(
      JSON.stringify({
        key: "loadOffers",
        payload: {
          cardNumber: cardNumber,
          user_id: payload.userId,
          legacy: false,
          offers: payload.offers,
        },
      })
    );
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/offerRequest`,
      {
        method: "POST",
        headers: {
          focus: `${payload.token}`,
          Authorization: `Bearer ${encrypt(crypto.randomUUID()).toUpperCase()}`,
          "Content-Type": "application/json",
          "x-nonce-token": generateNonce(),
          "is-email": payload.isHash ? "true" : "false",
        },
        body: JSON.stringify({ data }),
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch all offers. Status: ${response.status}`);
    }

    const responseData = await response.json();
    const finalResponse = await fetchSafeJson(responseData);
    loadOffers("success", "en", payload.offers?.length);
    return await finalResponse;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch all offers");
  }
};

export const mulesoftValidateMember = async (payload: {
  key: string;
  emailOfferUniqueIdentifier?: string;
  cardNumber?: string;
  legacy?: string;
  token: string;
  isHash?: boolean;
}): Promise<any | null> => {
  try {
    const cardNumber = payload.isHash? payload?.cardNumber :'';
    const data = encrypt(
      JSON.stringify({
        key: "validateMember",
        payload: {
          emailOfferUniqueIdentifier: payload?.emailOfferUniqueIdentifier,
          cardNumber: cardNumber,
          legacy: payload?.legacy,
        },
      })
    );
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/offerRequest`,
      {
        method: "POST",
        headers: {
          focus: `${payload.token}`,
          Authorization: `Bearer ${encrypt(crypto.randomUUID()).toUpperCase()}`,
          "Content-Type": "application/json",
          "x-nonce-token": generateNonce(),
          "is-email": payload.isHash ? "true" : "false",
        },
        body: JSON.stringify({ data }),
      }
    );
    if (!response.ok) {
      throw new Error(
        `Failed to fetch validate member. Status: ${response.status}`
      );
    }
    const responseData = await response.json();
    return await fetchSafeJson(responseData);
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch all offers");
  }
};

// add offers to Favourite list

export const addOffersToList = async (payload: any, token: string, quantity?: number) => {
  try {
    const data = encrypt(payload);
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/favOffers`,
      {
        method: "POST",
        headers: {
          focus: `${token}`,
          Authorization: `Bearer ${encrypt(crypto.randomUUID()).toUpperCase()}`,
          "Content-Type": "application/json",
          "x-nonce-token": generateNonce(),
        },
        // body: encrypt(data),
        body: JSON.stringify({ data }),
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch all offers. Status: ${response.status}`);
    }

    const responseData = await response.json();
    console.log("responseData", responseData);
    return await fetchSafeJson(responseData);
  } catch (error: any) {
    console.log(error);
    throw new Error("Failed to Add fav. Offer");
  }
};

// Delete offers to Favourite list

export const deleteOffersFromList = async (data: any) => {
  try {
    let url = `${process.env.NEXT_PUBLIC_BASE_URL}/api/favOffers`
    if (!data?.bulk) {
      url += `?offer_id=${data.offer_id}`
    }
    const response = await fetch(
      url,
      {
        method: "DELETE",
        headers: {
          focus: `${data.token}`,
          Authorization: `Bearer ${encrypt(crypto.randomUUID()).toUpperCase()}`,
          "Content-Type": "application/json",
          "x-nonce-token": generateNonce(),
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch all offers. Status: ${response.status}`);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error: any) {
    console.log(error);
    throw new Error("Failed to Delete fav. Offer");
  }
};

// Get offers to Favourite list

export const getOffersFromList = async (data: any) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/api/favOffers?preferredLanguage=${data.preferredLanguage}`,
      {
        method: "GET",
        headers: {
          focus: `${data.token}`,
          Authorization: `Bearer ${encrypt(crypto.randomUUID()).toUpperCase()}`,
          "Content-Type": "application/json",
          "x-nonce-token": generateNonce(),
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch all offers. Status: ${response.status}`);
    }

    const responseData = await response.json();
    return await fetchSafeJson(responseData);
  } catch (error: any) {
    console.log(error);
    throw new Error("Failed to Get fav. Offers");
  }
};
